// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Кабинет v2 — общие стили по утверждённому макету «Кабинет RiChat v2 — редизайн»
 * (claude/Cabinet_v2_screens.md). Палитра RiChat, шрифт Inter.
 * Классы с префиксом v2- — общие для всех экранов; стили конкретного экрана —
 * рядом с его компонентом.
 */

:root {
  --v2-primary: #1f2937;
  --v2-text: #1f2937;
  --v2-text-strong: #1a1a1a;
  --v2-text-2: #374151;
  --v2-muted: #6b7280;
  --v2-faint: #9ca3af;
  --v2-border: #e5e7eb;
  --v2-border-soft: #f3f4f6;
  --v2-bg: #f9fafb;
  --v2-card: #ffffff;
  --v2-hover: #f3f4f6;
  --v2-green: #16a34a;
  --v2-green-text: #15803d;
  --v2-green-bg: #dcfce7;
  --v2-orange: #b45309;
  --v2-orange-bg: #fff7e6;
  --v2-red: #dc2626;
  --v2-blue: #2563eb;
  --v2-blue-bg: #eff6ff;
}

.v2-app {
  font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  color: var(--v2-text);
  background: var(--v2-bg);
  min-height: 100vh;
  display: flex;
  font-size: 14px;
  line-height: 1.45;
}
.v2-app a {
  color: var(--v2-primary);
  text-decoration: none;
}
.v2-app a:hover {
  color: var(--v2-text-2);
}
.v2-app h1,
.v2-app h2,
.v2-app h3 {
  color: var(--v2-text);
}

/* ── Левое меню ─────────────────────────────────────────────────────────── */
.v2-nav {
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  flex: 0 0 240px;
  width: 240px;
  background: var(--v2-card);
  border-right: 1px solid var(--v2-border);
  padding: 20px 14px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  z-index: 6;
}
.v2-nav-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  flex-shrink: 0;
}
.v2-logo {
  font-weight: 800;
  font-size: 19px;
  letter-spacing: 0.06em;
  color: var(--v2-primary);
}
.v2-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 0;
  background: transparent;
  color: var(--v2-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}
.v2-icon-btn:hover {
  background: var(--v2-hover);
  color: var(--v2-primary);
}
.v2-nav-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin: 0 -14px -20px;
  padding: 0 14px 20px;
}
.v2-nav-body > * {
  flex-shrink: 0;
}
.v2-new-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  border-radius: 10px;
  background: var(--v2-primary);
  color: #fff !important;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  white-space: nowrap;
}
.v2-new-btn:hover {
  background: #374151;
}
.v2-nav-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.v2-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  color: var(--v2-text-2) !important;
  white-space: nowrap;
}
.v2-nav-item:hover {
  background: var(--v2-bg);
}
.v2-nav-item.is-active {
  background: var(--v2-hover);
  color: var(--v2-primary) !important;
  font-weight: 600;
}
.v2-nav-caption {
  padding: 0 12px 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--v2-muted);
  letter-spacing: 0.04em;
}
.v2-nav-assistant {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  color: var(--v2-primary) !important;
}
.v2-nav-assistant:hover {
  background: var(--v2-bg);
}
.v2-nav-assistant.is-open {
  font-weight: 600;
}
.v2-nav-assistant .v2-name {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v2-nav-sub {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin: 2px 0 6px 25px;
  padding-left: 9px;
  border-left: 1px solid var(--v2-border);
}
.v2-nav-subitem {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 6px 10px;
  border-radius: 7px;
  font-size: 13px;
  color: var(--v2-text-2) !important;
  white-space: nowrap;
}
.v2-nav-subitem:hover {
  background: var(--v2-bg);
}
.v2-nav-subitem.is-active {
  background: var(--v2-border);
  color: var(--v2-primary) !important;
  font-weight: 600;
}
.v2-nav-foot {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-top: 1px solid var(--v2-border);
  padding-top: 14px;
}
.v2-nav-foot .v2-nav-item {
  padding: 9px 12px;
}
.v2-nav-foot .v2-nav-item span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Свёрнутое меню — полоса иконок */
.v2-nav.is-collapsed {
  flex: 0 0 60px;
  width: 60px;
  padding: 16px 8px;
  align-items: center;
  gap: 6px;
}
.v2-nav.is-collapsed .v2-nav-body {
  align-items: center;
  gap: 6px;
  margin: 0 -8px -16px;
  padding: 0 8px 16px;
}
.v2-nav-icon {
  width: 40px;
  height: 40px;
  border-radius: 9px;
  color: var(--v2-text-2) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
}
.v2-nav-icon:hover {
  background: var(--v2-bg);
}
.v2-nav-icon.is-active {
  background: var(--v2-hover);
  color: var(--v2-primary) !important;
}
.v2-nav-icon.is-sub {
  height: 36px;
}
.v2-nav-icon.is-sub.is-active {
  background: var(--v2-border);
}
.v2-nav-sep {
  width: 28px;
  border-top: 1px solid var(--v2-border);
  margin: 6px 0;
}
.v2-nav-icon .v2-dot-badge {
  position: absolute;
  right: 4px;
  top: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-sizing: content-box;
}

/* ── Аватар-буква и точка статуса ───────────────────────────────────────── */
.v2-avatar {
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex: none;
}
.v2-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
}

/* ── Страница ───────────────────────────────────────────────────────────── */
.v2-main {
  flex: 1 1 560px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.v2-topbar {
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--v2-card);
  border-bottom: 1px solid var(--v2-border);
  padding: 10px 28px;
  min-height: 56px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 28px;
}
.v2-topbar.is-section {
  background: var(--v2-bg);
  padding: 10px 24px;
  gap: 12px;
}
.v2-topbar h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
}
.v2-topbar.is-section h1 {
  font-size: 16px;
}
.v2-topbar .v2-topbar-hint {
  font-size: 13px;
  color: var(--v2-muted);
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
}
.v2-topbar .v2-topbar-actions {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.v2-topbar-block {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 28px;
  border-left: 1px solid var(--v2-border);
}
.v2-content {
  padding: 18px 28px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}
.v2-content > * {
  min-width: 0;
}
.v2-content.is-section {
  padding: 14px 24px 24px;
  gap: 14px;
}

/* ── Карточки, заголовки, таблицы ───────────────────────────────────────── */
.v2-card {
  background: var(--v2-card);
  border: 1px solid var(--v2-border);
  border-radius: 12px;
}
.v2-card-pad {
  padding: 14px 16px;
}
.v2-h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}
.v2-muted {
  color: var(--v2-muted);
}
.v2-small {
  font-size: 13px;
}
.v2-xs {
  font-size: 12px;
}
.v2-link {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}
.v2-table-wrap {
  overflow-x: auto;
  position: relative;
}
.v2-table {
  width: 100%;
  border-collapse: collapse;
}
.v2-table th {
  text-align: left;
  font-size: 12px;
  color: var(--v2-muted);
  font-weight: 600;
  padding: 9px 12px;
  white-space: nowrap;
}
.v2-table td {
  padding: 10px 12px;
  white-space: nowrap;
  border-top: 1px solid var(--v2-border-soft);
}
.v2-table td.v2-wrap {
  white-space: normal;
  min-width: 200px;
}
.v2-table th:first-child,
.v2-table td:first-child {
  padding-left: 16px;
}
.v2-table th:last-child,
.v2-table td:last-child {
  padding-right: 16px;
}
.v2-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  left: 0;
  top: 0;
}

/* ── Кнопки ─────────────────────────────────────────────────────────────── */
.v2-btn {
  height: 34px;
  padding: 0 16px;
  border-radius: 9px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: var(--v2-primary);
  font: inherit;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}
.v2-btn:hover {
  border-color: var(--v2-primary);
}
.v2-btn.is-primary {
  border: 0;
  background: var(--v2-primary);
  color: #fff;
}
.v2-btn.is-primary:hover {
  background: #374151;
}
.v2-btn:disabled,
.v2-btn.is-disabled {
  background: var(--v2-border);
  color: var(--v2-faint);
  border-color: var(--v2-border);
  cursor: default;
  pointer-events: none;
}

/* Подвал с реквизитами (требование ЮKassa) — скромно внизу страницы */
.v2-legal {
  padding: 14px 28px 18px;
  font-size: 12px;
  color: var(--v2-faint);
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
}
.v2-legal a {
  color: var(--v2-muted) !important;
}

/* Серия O: сколько запросов клиентов ждут оператора (красная точка в меню). */
.v2-nav-count {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/v2.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4EAA4E;EAC5E,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA,8EAA8E;AAC9E;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,OAAO;EACP,MAAM;AACR;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/*\n * Кабинет v2 — общие стили по утверждённому макету «Кабинет RiChat v2 — редизайн»\n * (claude/Cabinet_v2_screens.md). Палитра RiChat, шрифт Inter.\n * Классы с префиксом v2- — общие для всех экранов; стили конкретного экрана —\n * рядом с его компонентом.\n */\n\n:root {\n  --v2-primary: #1f2937;\n  --v2-text: #1f2937;\n  --v2-text-strong: #1a1a1a;\n  --v2-text-2: #374151;\n  --v2-muted: #6b7280;\n  --v2-faint: #9ca3af;\n  --v2-border: #e5e7eb;\n  --v2-border-soft: #f3f4f6;\n  --v2-bg: #f9fafb;\n  --v2-card: #ffffff;\n  --v2-hover: #f3f4f6;\n  --v2-green: #16a34a;\n  --v2-green-text: #15803d;\n  --v2-green-bg: #dcfce7;\n  --v2-orange: #b45309;\n  --v2-orange-bg: #fff7e6;\n  --v2-red: #dc2626;\n  --v2-blue: #2563eb;\n  --v2-blue-bg: #eff6ff;\n}\n\n.v2-app {\n  font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;\n  color: var(--v2-text);\n  background: var(--v2-bg);\n  min-height: 100vh;\n  display: flex;\n  font-size: 14px;\n  line-height: 1.45;\n}\n.v2-app a {\n  color: var(--v2-primary);\n  text-decoration: none;\n}\n.v2-app a:hover {\n  color: var(--v2-text-2);\n}\n.v2-app h1,\n.v2-app h2,\n.v2-app h3 {\n  color: var(--v2-text);\n}\n\n/* ── Левое меню ─────────────────────────────────────────────────────────── */\n.v2-nav {\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n  height: 100vh;\n  flex: 0 0 240px;\n  width: 240px;\n  background: var(--v2-card);\n  border-right: 1px solid var(--v2-border);\n  padding: 20px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  z-index: 6;\n}\n.v2-nav-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 10px;\n  flex-shrink: 0;\n}\n.v2-logo {\n  font-weight: 800;\n  font-size: 19px;\n  letter-spacing: 0.06em;\n  color: var(--v2-primary);\n}\n.v2-icon-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 0;\n  background: transparent;\n  color: var(--v2-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  padding: 0;\n}\n.v2-icon-btn:hover {\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n}\n.v2-nav-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  margin: 0 -14px -20px;\n  padding: 0 14px 20px;\n}\n.v2-nav-body > * {\n  flex-shrink: 0;\n}\n.v2-new-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  border-radius: 10px;\n  background: var(--v2-primary);\n  color: #fff !important;\n  font-weight: 600;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.v2-new-btn:hover {\n  background: #374151;\n}\n.v2-nav-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.v2-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: var(--v2-text-2) !important;\n  white-space: nowrap;\n}\n.v2-nav-item:hover {\n  background: var(--v2-bg);\n}\n.v2-nav-item.is-active {\n  background: var(--v2-hover);\n  color: var(--v2-primary) !important;\n  font-weight: 600;\n}\n.v2-nav-caption {\n  padding: 0 12px 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--v2-muted);\n  letter-spacing: 0.04em;\n}\n.v2-nav-assistant {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  color: var(--v2-primary) !important;\n}\n.v2-nav-assistant:hover {\n  background: var(--v2-bg);\n}\n.v2-nav-assistant.is-open {\n  font-weight: 600;\n}\n.v2-nav-assistant .v2-name {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.v2-nav-sub {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin: 2px 0 6px 25px;\n  padding-left: 9px;\n  border-left: 1px solid var(--v2-border);\n}\n.v2-nav-subitem {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 6px 10px;\n  border-radius: 7px;\n  font-size: 13px;\n  color: var(--v2-text-2) !important;\n  white-space: nowrap;\n}\n.v2-nav-subitem:hover {\n  background: var(--v2-bg);\n}\n.v2-nav-subitem.is-active {\n  background: var(--v2-border);\n  color: var(--v2-primary) !important;\n  font-weight: 600;\n}\n.v2-nav-foot {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border-top: 1px solid var(--v2-border);\n  padding-top: 14px;\n}\n.v2-nav-foot .v2-nav-item {\n  padding: 9px 12px;\n}\n.v2-nav-foot .v2-nav-item span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Свёрнутое меню — полоса иконок */\n.v2-nav.is-collapsed {\n  flex: 0 0 60px;\n  width: 60px;\n  padding: 16px 8px;\n  align-items: center;\n  gap: 6px;\n}\n.v2-nav.is-collapsed .v2-nav-body {\n  align-items: center;\n  gap: 6px;\n  margin: 0 -8px -16px;\n  padding: 0 8px 16px;\n}\n.v2-nav-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 9px;\n  color: var(--v2-text-2) !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n.v2-nav-icon:hover {\n  background: var(--v2-bg);\n}\n.v2-nav-icon.is-active {\n  background: var(--v2-hover);\n  color: var(--v2-primary) !important;\n}\n.v2-nav-icon.is-sub {\n  height: 36px;\n}\n.v2-nav-icon.is-sub.is-active {\n  background: var(--v2-border);\n}\n.v2-nav-sep {\n  width: 28px;\n  border-top: 1px solid var(--v2-border);\n  margin: 6px 0;\n}\n.v2-nav-icon .v2-dot-badge {\n  position: absolute;\n  right: 4px;\n  top: 5px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  box-sizing: content-box;\n}\n\n/* ── Аватар-буква и точка статуса ───────────────────────────────────────── */\n.v2-avatar {\n  border-radius: 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  flex: none;\n}\n.v2-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex: none;\n}\n\n/* ── Страница ───────────────────────────────────────────────────────────── */\n.v2-main {\n  flex: 1 1 560px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n.v2-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background: var(--v2-card);\n  border-bottom: 1px solid var(--v2-border);\n  padding: 10px 28px;\n  min-height: 56px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 28px;\n}\n.v2-topbar.is-section {\n  background: var(--v2-bg);\n  padding: 10px 24px;\n  gap: 12px;\n}\n.v2-topbar h1 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.v2-topbar.is-section h1 {\n  font-size: 16px;\n}\n.v2-topbar .v2-topbar-hint {\n  font-size: 13px;\n  color: var(--v2-muted);\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 0 1 auto;\n}\n.v2-topbar .v2-topbar-actions {\n  margin-left: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n.v2-topbar-block {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-left: 28px;\n  border-left: 1px solid var(--v2-border);\n}\n.v2-content {\n  padding: 18px 28px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n.v2-content > * {\n  min-width: 0;\n}\n.v2-content.is-section {\n  padding: 14px 24px 24px;\n  gap: 14px;\n}\n\n/* ── Карточки, заголовки, таблицы ───────────────────────────────────────── */\n.v2-card {\n  background: var(--v2-card);\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n}\n.v2-card-pad {\n  padding: 14px 16px;\n}\n.v2-h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n.v2-muted {\n  color: var(--v2-muted);\n}\n.v2-small {\n  font-size: 13px;\n}\n.v2-xs {\n  font-size: 12px;\n}\n.v2-link {\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.v2-table-wrap {\n  overflow-x: auto;\n  position: relative;\n}\n.v2-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.v2-table th {\n  text-align: left;\n  font-size: 12px;\n  color: var(--v2-muted);\n  font-weight: 600;\n  padding: 9px 12px;\n  white-space: nowrap;\n}\n.v2-table td {\n  padding: 10px 12px;\n  white-space: nowrap;\n  border-top: 1px solid var(--v2-border-soft);\n}\n.v2-table td.v2-wrap {\n  white-space: normal;\n  min-width: 200px;\n}\n.v2-table th:first-child,\n.v2-table td:first-child {\n  padding-left: 16px;\n}\n.v2-table th:last-child,\n.v2-table td:last-child {\n  padding-right: 16px;\n}\n.v2-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  left: 0;\n  top: 0;\n}\n\n/* ── Кнопки ─────────────────────────────────────────────────────────────── */\n.v2-btn {\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 9px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: var(--v2-primary);\n  font: inherit;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.v2-btn:hover {\n  border-color: var(--v2-primary);\n}\n.v2-btn.is-primary {\n  border: 0;\n  background: var(--v2-primary);\n  color: #fff;\n}\n.v2-btn.is-primary:hover {\n  background: #374151;\n}\n.v2-btn:disabled,\n.v2-btn.is-disabled {\n  background: var(--v2-border);\n  color: var(--v2-faint);\n  border-color: var(--v2-border);\n  cursor: default;\n  pointer-events: none;\n}\n\n/* Подвал с реквизитами (требование ЮKassa) — скромно внизу страницы */\n.v2-legal {\n  padding: 14px 28px 18px;\n  font-size: 12px;\n  color: var(--v2-faint);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n}\n.v2-legal a {\n  color: var(--v2-muted) !important;\n}\n\n/* Серия O: сколько запросов клиентов ждут оператора (красная точка в меню). */\n.v2-nav-count {\n  margin-left: auto;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
